module.exports = __webpack_public_path__ + "static/media/thumbnail_CHARGING.c56f6ae3.png";